class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();
    this.mainDetailsToggle = this.querySelector('details');
    this.content = this.mainDetailsToggle.querySelector('summary').nextElementSibling;

    this.mainDetailsToggle.addEventListener('focusout', this.onFocusOut.bind(this));
    this.mainDetailsToggle.addEventListener('toggle', this.onToggle.bind(this));
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    });
  }

  onToggle() {
    if (!this.animations) this.animations = this.content.getAnimations();

    if (this.mainDetailsToggle.hasAttribute('open')) {
      this.animations.forEach((animation) => animation.play());
    } else {
      this.animations.forEach((animation) => animation.cancel());
    }
  }

  close() {
    this.mainDetailsToggle.removeAttribute('open');
    this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', false);
  }
}

customElements.define('details-disclosure', DetailsDisclosure);

class HeaderMenu extends DetailsDisclosure {
  constructor() {
    super();
    this.header = document.querySelector('.header-wrapper');
    this.summary = this.mainDetailsToggle.querySelector('summary');
    this.submenu = this.summary.nextElementSibling;
    this.hoverTimer = null;

    const desktop = () => window.matchMedia('(min-width: 990px)').matches;

    const openMenu = () => {
      if (!desktop()) return;
      clearTimeout(this.hoverTimer);
      this.mainDetailsToggle.open = true;
      this.summary.setAttribute('aria-expanded', 'true');
    };

    const keepOpen = () => {
      if (!desktop()) return;
      clearTimeout(this.hoverTimer);
    };

    const scheduleClose = () => {
      if (!desktop()) return;
      clearTimeout(this.hoverTimer);
      this.hoverTimer = setTimeout(() => {
        if (!this.summary.matches(':hover') && !this.submenu.matches(':hover')) {
          this.close();
        }
      }, 300);
    };

    this.summary.addEventListener('mouseenter', openMenu);
    this.summary.addEventListener('mouseleave', scheduleClose);
    this.submenu.addEventListener('mouseenter', keepOpen);
    this.submenu.addEventListener('mouseleave', scheduleClose);
  }

  onToggle() {
    if (!this.header) return;
    this.header.preventHide = this.mainDetailsToggle.open;

    if (document.documentElement.style.getPropertyValue('--header-bottom-position-desktop') !== '') return;
    document.documentElement.style.setProperty(
      '--header-bottom-position-desktop',
      `${Math.floor(this.header.getBoundingClientRect().bottom)}px`
    );
  }
}

customElements.define('header-menu', HeaderMenu);
